import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import 'rxjs/add/operator/toPromise';
import {webapi} from '../../../shared/my-constants';
import {Observable} from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import {tap} from 'rxjs/operators';


@Injectable()
export class LabReportsService {
  private headers = new Headers({'Content-Type': 'application/json'});
  /* Owername :Vijay Patil
    Date : 1-1-2018  */
  private listAllnew = webapi + 'tpath_bs/finalized_lol_listnew/';
  private listTestOrder = webapi + 'tpath_bs/test_order_list/?';
  private listOfTestReports = webapi + 'mpath_test_result/test_reports/?';
  private submissionReport = webapi + 'mpath_test_result/submissionreport/?';
  private searchByAllColurl = webapi + 'mpath_test_result/searchall/?';
  private listbyVisitId = webapi + 'mpath_test_result/getbyvisitid/?';
  private getParamByAgeandGender = webapi + 'mpath_parameter_range/parambyageandgender/';
  private GetReportByPsId = webapi + 'mpath_result/get_report_by_psid/';
  private GetByItemRecords= webapi+'inv_service_wise_consumption/getItemsbyserviceId/';
  private GetAvailability= webapi+'tinv_opening_balance_item/getItemAvailabityBy/';
  private finalizeReport = webapi + 'mpath_test_result/finalizereport/';
  private finalizeReportTpathOnly = webapi + 'tpath_bs/onlyfinalizedtpathbs/';
  private Getfilebasepath = webapi + 'tpath_bs/getfilebasepath/';
  private ListByPatientId = webapi + 'tpath_bs/get_by_patientid/';
  private ListByPsID = webapi + 'mpath_test_result/getByPsId/';
  private SaveServiceTransactions = webapi + 'trn_service_wise_package/trnservice/create';
  private SaveItemTransactions = webapi + 'trn_service_wise_package/trnitems/create';
    constructor(private http: Http) {
  }

  addFinalizeReport(model: any): Promise<any> {
    return this.http.post(this.finalizeReport, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  addSubmissionReport(model: any): Promise<any> {
    return this.http.post(this.submissionReport, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  // new function
  getAllParamByAgeGender(currentPage: any, size: any, jsonString: any, sort: any, col: any): Promise<any> {
    return this.http.put(this.getParamByAgeandGender, JSON.stringify(jsonString), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  // new function
  getAllServiceRecordService(currentPage: any, size: any, jsonString: any, sort: any, col: any): Observable<any> {
    return this.http.put(this.listAllnew + currentPage + '/' + size + '/' + sort + '/' + col, JSON.stringify(jsonString), {headers: this.headers})
      .map(response => response.json())
      .pipe(
        tap(
          error => this.logError(error)
        ));
  }

// old function
  /*  getAllServiceRecordService(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
      return this.http.get(this.listAll + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col)
        .toPromise()
        .then(response => response.json())
        .catch(this.handleError);
    }*/
  getAllTestRecordService(currentPage: any, size: any, qString: any, billId: any, sort: any, col: any): Promise<any> {
    return this.http.get(this.listTestOrder + 'page=' + currentPage + '&size=' + size + '&qString=' + '' + '&billId=' + billId + '&sort=' + sort + '&col=' + col)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getByVisitIdRecordService(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
    return this.http.get(this.listbyVisitId + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getAllTestReports(currentPage: any, size: any, qString: any, billId: any, isIPD: any, sort: any, col: any): Observable<any> {
    return this.http.get(this.listOfTestReports + 'page=' + currentPage + '&size=' + size + '&qString=' + '' + '&billId=' + billId + '&isIPD=' + isIPD + '&sort=' + sort + '&col=' + col)
      .map(response => response.json())
      .pipe(
        tap(
          error => this.logError(error)
        ));
  }

  //for EMR
  getReportByPsId(psId: any): Promise<any> {
    return this.http.get(this.GetReportByPsId + psId)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }


    getRecordByAvailability(storeId: any,model:any): Promise<any> {
        return this.http.post(this.GetAvailability + storeId ,  JSON.stringify(model),{headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

  getItemRecordById(Id: any): Promise<any> {
        return this.http.get(this.GetByItemRecords + Id)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    saveServiceTransaction(model: any): Promise<any>{
        return this.http.post(this.SaveServiceTransactions, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    saveItemTransaction(model:any): Promise<any>{
        return this.http.post(this.SaveItemTransactions,  JSON.stringify(model),{headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

  private handleError(error: Response | any) {
    return Promise.reject(error.message || error);
  }

  private logError(error: Response | any) {
    return Observable.throw(error.message || error);
  }

  /*  private logError(error: HttpErrorResponse) {
      if (error.error instanceof ErrorEvent) {
        //  A client-side or network error occurred. Handle it accordingly.
        console.error('An error occurred:', error.error.message);
      } else {
        //  The backend returned an unsuccessful response code.
        //  The response body may contain clues as to what went wrong,
        console.error(
          `Backend returned code ${error.status}, ` +
          `body was: ${error.error}`);
      }
      //  return an ErrorObservable with a user-facing error message
      return new ErrorObservable(
        'Something bad happened; please try again later.');
    };*/
    getFilebasepath() {
        return this.http.get(this.Getfilebasepath)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    gettpathbsBypatientidservice(id: any) {
        return this.http.get(this.ListByPatientId + id)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }
    getMptahREsultByPsIdservice(id: any) {
        return this.http.get(this.ListByPsID + id)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/investigation/pathology/lab_report/lab_reports.service.ts